import { authService } from './auth';

/**
 * Devuelve la empresa "actual" del contexto:
 * - Master/superadmin: la seleccionada en el panel (localStorage) o su empresa principal.
 * - Otros roles: siempre su empresa principal.
 */
export function getCurrentCompanyId() {
  const user = authService.getUser();
  if (user && ['master', 'superadmin'].includes(user.role_id)) {
    return localStorage.getItem('current_company_id') || user.company_id || '';
  }
  return user?.company_id || '';
}

export function isMasterRole() {
  const user = authService.getUser();
  return user && ['master', 'superadmin'].includes(user.role_id);
}
